module.exports = __webpack_public_path__ + "img/thumbnail_Addax_m_normal.c34fde08.png";